import React, { useState, useEffect } from 'react';
import { Section } from '@prosolve/common-components-ui'
import LoadingOverlay from "../sharedComponents/LoadingOverlay";
import TrainerDashboardSummarySection from './TrainerDashboardSummarySection';
import TrainerDashboardRecentCompensationSection from './TrainerDashboardRecentCompensationSection';
import TrainerDashboardModulesCompleted from './TrainerDashboardModulesCompleted';

export default () => {

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{
      display: 'flex',
      padding: '5px 20px', 
      columnGap: '20px'
    }}>
      {
        isLoading &&
        <LoadingOverlay backgroundColor='#ffffff' width='calc(100vw - 55px)' marginTop='45px' marginLeft='20px' transparent={false} />
      }
      <Section style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <TrainerDashboardSummarySection />
        <TrainerDashboardRecentCompensationSection />
        <TrainerDashboardModulesCompleted />
      </Section>
    </div>
  )
}